<template>
  <page :title="title" :breadcrumb="breadcrumb" :manualInit="stdRisk.init" :manualErr="stdRisk.initErr" @reload="doInit">
    <div>
      <transition name="slide-x-transition" mode="out-in">
        <router-view @doNewStdRisk="doNewStdRisk"></router-view>
      </transition>
    </div>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      newMode: null,
      title: null,
      breadcrumb: null
    }
  },
  computed: {
    ...mapGetters([
      'derieveBreadcrumbByName'
    ]),
    stdRisk() {
      return this.$store.state.parameters.stdRisk
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('stdRiskInit')
    },
    doNewStdRisk(value) {
      this.newMode = value
      this.doStdRiskTitle()
    },
    doStdRiskTitle() {
      if (this.newMode) {
        this.title = 'New Standard Risk Text'
        this.breadcrumb = this.derieveBreadcrumbByName('stdRiskText')
        this.breadcrumb.push({ name: 'stdRiskTextReview', text: this.title })
      } else {
        this.title = null
        this.breadcrumb = null
      }
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [
    routeMixin
  ]
}
</script>

<style>
</style>
